import {
	isRouteErrorResponse,
	Links,
	Meta,
	Outlet,
	Scripts,
	ScrollRestoration,
	useRouteError,
} from "react-router";

import "@workspace/ui/tailwind.css";
import type { Route } from "./+types/root";
import Logo from "./components/logo";

export const loader = async ({ request }: Route.LoaderArgs) => {
	const url = new URL(request.url);
	const searchParams = url.searchParams;
	const previewMode = searchParams.get("preview") === "true";
	return { previewMode };
};

export function ErrorBoundary() {
	const error = useRouteError();

	return (
		<html lang="no">
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<Meta />
				<Links />
				<link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" />
				<link rel="icon" type="image/svg+xml" href="/favicon.svg" />
				<link rel="shortcut icon" href="/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
				<meta name="apple-mobile-web-app-title" content="Billies Kitchen" />
				<link rel="manifest" href="/site.webmanifest" />
			</head>
			<body>
				<div className="container mx-auto flex flex-col items-center justify-center gap-8 px-4 py-8">
					<Logo className="h-auto w-64" />
					<h1 className="font-bold text-3xl">Oops! Something went wrong.</h1>
					{isRouteErrorResponse(error) ? (
						<>
							<p className="mb-4 font-bold text-5xl">{error.status}</p>
							<p className="mb-4">{error.data}</p>
						</>
					) : error instanceof Error ? (
						<p className="mb-4">Error: {error.message}</p>
					) : (
						<p className="mb-4">An unexpected error occurred.</p>
					)}
					<a href="/" className="text-primary underline">
						Gå tilbake til forsiden
					</a>
				</div>
				<Scripts />
			</body>
		</html>
	);
}

export default function App({ loaderData }: Route.ComponentProps) {
	const { previewMode } = loaderData;
	return (
		<html lang="no">
			<head>
				<meta charSet="utf-8" />
				<meta name="viewport" content="width=device-width, initial-scale=1" />
				<Meta />
				<Links />
				<link rel="icon" type="image/png" href="/favicon-96x96.png" sizes="96x96" />
				<link rel="icon" type="image/svg+xml" href="/favicon.svg" />
				<link rel="shortcut icon" href="/favicon.ico" />
				<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png" />
				<meta name="apple-mobile-web-app-title" content="Billies Kitchen" />
				<link rel="manifest" href="/site.webmanifest" />
				{previewMode && (
					<script src="https://app.crystallize.com/static/frontend-preview-listener.js" />
				)}
			</head>
			<body>
				<Outlet />
				<ScrollRestoration />
				<Scripts />
			</body>
		</html>
	);
}
